(function () {
  function isEmailValid(email) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(email);
  }
  function isE164(phone) {
    return /^\+[1-9]\d{6,14}$/.test(phone);
  }
  function readCookie(name) {
    const match = document.cookie.match(
      new RegExp("(?:^|; )" + name.replace(/([.$?*|{}()\[\]\\\/\+^])/g, "\\$1") + "=([^;]*)")
    );
    return match ? decodeURIComponent(match[1]) : "";
  }
  function num(v) {
    const n = parseFloat(String(v ?? "").replace(",", "."));
    return Number.isFinite(n) ? n : 0;
  }
  function clamp(v, min, max) {
    return Math.min(Math.max(v, min), max);
  }
  function splitName(full) {
    const parts = String(full || "").trim().split(/\s+/).filter(Boolean);
    if (!parts.length) return { first: "", last: "" };
    if (parts.length === 1) return { first: "", last: parts[0] };
    return { first: parts[0], last: parts.slice(1).join(" ") };
  }

  const nfEUR0 = new Intl.NumberFormat("fi-FI", { style: "currency", currency: "EUR", maximumFractionDigits: 0 });
  const nfEUR2 = new Intl.NumberFormat("fi-FI", { style: "currency", currency: "EUR", minimumFractionDigits: 2, maximumFractionDigits: 2 });
  const nfNum1 = new Intl.NumberFormat("fi-FI", { minimumFractionDigits: 1, maximumFractionDigits: 1 });

  function fmtEUR(n) {
    if (!Number.isFinite(n)) n = 0;
    return Math.abs(n) < 100 ? nfEUR2.format(n) : nfEUR0.format(n);
  }

  function initRoot(root) {
    const sectionId = root.getAttribute("data-section-id") || "";
    const storageKey = "fc_calc_payload_" + sectionId;

    const q = (sel) => root.querySelector(sel);
    const inEl = (key) => q(`[data-fc="${key}"]`);
    const outEl = (key) => q(`[data-fc-out="${key}"]`);

    const form = q("[data-finbin-form]");
    const btn = q("[data-finbin-submit]");
    const resetBtn = q("[data-finbin-reset]");
    const results = q("[data-finbin-results]");
    const locked = q("[data-finbin-results-locked]");
    const err = q("[data-finbin-error]");
    const ok = q("[data-finbin-success]");

    if (!form || !btn) return;

    function showError(msg) {
      if (err) { err.style.display = ""; err.textContent = msg; }
      if (ok) { ok.style.display = "none"; ok.textContent = ""; }
    }
    function showSuccess(msg) {
      if (ok) { ok.style.display = ""; ok.textContent = msg; }
      if (err) { err.style.display = "none"; err.textContent = ""; }
    }
    function clearMsgs() {
      if (err) { err.style.display = "none"; err.textContent = ""; }
      if (ok) { ok.style.display = "none"; ok.textContent = ""; }
    }

    function calcValues() {
      const B4  = Math.max(0, Math.round(num(inEl("bins")?.value)));
      const B5  = Math.max(0, num(inEl("freq_month")?.value));
      const B6  = Math.max(0, num(inEl("cost_per")?.value));

      const redPct = clamp(num(inEl("reduction_pct")?.value), 0, 100);
      const B7  = redPct / 100;

      const B8  = Math.max(0, num(inEl("license_year")?.value));
      const B9  = Math.max(0, num(inEl("install_one_time")?.value));
      const B10 = Math.max(1, Math.round(num(inEl("contract_years")?.value)));

      const B14 = B5 * B6;
      const B15 = (B5 * B6) * 12;
      const B16 = B15 * (1 - B7);
      const B17 = B15 - B16;
      const B18 = B9 / B10; // used in calc only
      const B19 = B17 - B8 - B18;
      const B20 = B19 * B4;
      const B21 = B8 + B9;  // used for payback calc only
      const B22 = (B17 > 0) ? (B21 / B17) : 0;
      const B23 = (B22 > 0) ? (B22 * 12) : 0;
      const B27 = (B19 * B4) * B10;

      return { B4,B5,B6,B7,B8,B9,B10,B14,B15,B16,B17,B18,B19,B20,B21,B22,B23,B27 };
    }

    function forceShowResults() {
      if (results) results.style.setProperty("display", "grid", "important");
      if (locked) locked.style.setProperty("display", "none", "important");
    }

    function hideResults() {
      if (results) results.style.setProperty("display", "none", "important");
      if (locked) locked.style.setProperty("display", "", "important");
      const paybackRow = q("[data-fc-payback]");
      if (paybackRow) paybackRow.style.display = "none";
    }

    function render(v) {
      forceShowResults();

      outEl("empty_year").textContent = fmtEUR(v.B15);
      outEl("reduced_empty_year").textContent = fmtEUR(v.B16);
      outEl("gross_saving_bin_year").textContent = fmtEUR(v.B17);
      outEl("net_saving_bin_year").textContent = fmtEUR(v.B19);
      outEl("total_net_year").textContent = fmtEUR(v.B20);
      outEl("total_net_contract").textContent = fmtEUR(v.B27);

      const paybackRow = q("[data-fc-payback]");
      if (v.B22 > 0 && Number.isFinite(v.B22)) {
        if (paybackRow) paybackRow.style.display = "";
        outEl("payback_years").textContent = nfNum1.format(v.B22) + " vuotta";
        outEl("payback_months").textContent = nfNum1.format(v.B23) + " kk";
      } else {
        if (paybackRow) paybackRow.style.display = "none";
        outEl("payback_years").textContent = "–";
        outEl("payback_months").textContent = "–";
      }
    }

    function setSf(key, value) {
      const el = q(`[data-finbin-sf="${key}"]`);
      if (el) el.value = value == null ? "" : String(value);
    }

    function fillTracking() {
      const params = new URLSearchParams(window.location.search);
      setSf("utm_source__c", params.get("utm_source") || readCookie("utm_source") || "");
      setSf("utm_medium__c", params.get("utm_medium") || readCookie("utm_medium") || "");
      setSf("utm_campaign__c", params.get("utm_campaign") || readCookie("utm_campaign") || "");
      setSf("utm_term__c", params.get("utm_term") || readCookie("utm_term") || "");
      setSf("utm_content__c", params.get("utm_content") || readCookie("utm_content") || "");
      setSf("gclid__c", params.get("gclid") || readCookie("gclid") || "");
      setSf("landing_page__c", window.location.href);
      setSf("referrer__c", document.referrer || "");
    }

    function ensureFirstName(first) {
      let f = form.querySelector('input[name="first_name"]');
      if (!f) {
        f = document.createElement("input");
        f.type = "hidden";
        f.name = "first_name";
        form.appendChild(f);
      }
      f.value = first || "";
    }

    // UPDATED: description contains ONLY what is visible on page (no hidden assumptions)
    function buildDescription(lead, v) {
      const lines = [];

      const payback = (v.B22 > 0 && Number.isFinite(v.B22))
        ? (nfNum1.format(v.B22) + " vuotta (" + nfNum1.format(v.B23) + " kk)")
        : "–";


      lines.push("TULOKSET:");
      lines.push("Tyhjennyskustannus / vuosi: " + fmtEUR(v.B15));
      lines.push("Tyhjennysten kustannus (vähennyksen jälkeen) / vuosi: " + fmtEUR(v.B16));
      lines.push("Bruttosäästö / astia / vuosi: " + fmtEUR(v.B17));
      lines.push("Nettosäästö / astia / vuosi: " + fmtEUR(v.B19));
      lines.push("Nettosäästö yhteensä / vuosi: " + fmtEUR(v.B20));
      lines.push("Nettosäästö yhteensä / sopimuskausi: " + fmtEUR(v.B27));
      lines.push("Takaisinmaksuaika: " + payback);
      lines.push("");

      lines.push("SYÖTTEET:");
      lines.push("Roska-astioiden määrä (kpl): " + v.B4);
      lines.push("Tyhjennyskerrat / kk: " + (Number.isFinite(v.B5) ? nfNum1.format(v.B5) : v.B5));
      lines.push("Tyhjennyksen hinta (€ / kerta): " + fmtEUR(v.B6));
      lines.push("");

      lines.push("YHTEYSTIEDOT:");
      lines.push("Nimi: " + (lead.fullName || ""));
      lines.push("Yritys: " + (lead.company || ""));
      lines.push("Sähköposti: " + (lead.email || ""));
      lines.push("Puhelin: " + (lead.phone || ""));

      return lines.join("\n");
    }

    function restoreIfSubmitted() {
      const params = new URLSearchParams(window.location.search);
      if (params.get("fc_submitted") !== sectionId) return;
      try {
        const raw = sessionStorage.getItem(storageKey);
        if (!raw) return;
        const payload = JSON.parse(raw);
        if (!payload || !payload.v) return;
        render(payload.v);
        showSuccess("Kiitos. Laskelma on lähetetty ja tulokset näkyvät tässä.");
      } catch (e) {}
    }

    function resetAll() {
      clearMsgs();

      ["bins","freq_month","cost_per","reduction_pct","license_year","install_one_time","contract_years"].forEach((key) => {
        const el = inEl(key);
        if (!el) return;
        const def = el.getAttribute("value");
        el.value = def != null ? def : "";
      });

      const fullNameEl = q('[data-finbin-lead="fullName"]');
      const companyEl = q('[data-finbin-lead="company"]');
      const emailEl = q('[data-finbin-lead="email"]');
      const phoneEl = q('[data-finbin-lead="phone"]');
      if (fullNameEl) fullNameEl.value = "";
      if (companyEl) companyEl.value = "";
      if (emailEl) emailEl.value = "";
      if (phoneEl) phoneEl.value = "";

      const consentEl = q('[data-finbin-lead="consent"]');
      if (consentEl) consentEl.checked = false;
      const mktEl = q('[data-finbin-lead="mkt"]');
      if (mktEl) mktEl.checked = false;

      setSf("description", "");
      setSf("subject", "finbin säästölaskuri");

      hideResults();
      btn.disabled = false;

      try {
        sessionStorage.removeItem(storageKey);
      } catch (e) {}

      showSuccess("Laskuri tyhjennetty. Voit aloittaa alusta.");
    }

    restoreIfSubmitted();

    if (resetBtn) {
      resetBtn.addEventListener("click", resetAll);
    }

    btn.addEventListener("click", function () {
      clearMsgs();

      const fullName = (q('[data-finbin-lead="fullName"]')?.value || "").trim();
      const company  = (q('[data-finbin-lead="company"]')?.value || "").trim();
      const email    = (q('[data-finbin-lead="email"]')?.value || "").trim();
      const phone    = (q('[data-finbin-lead="phone"]')?.value || "").trim();

      if (!fullName) return showError("Anna nimi.");
      if (!company) return showError("Anna yritys.");
      if (!email || !isEmailValid(email)) return showError("Anna toimiva sähköposti.");
      if (!phone || !isE164(phone)) return showError("Anna puhelin maakoodilla, esim. +358401234567.");

      const consentEl = q('[data-finbin-lead="consent"]');
      if (consentEl && !consentEl.checked) return showError("Hyväksy tietojen käyttö yhteydenottoon ja tarjoukseen.");

      const v = calcValues();
      render(v);

      fillTracking();

      const parts = splitName(fullName);
      ensureFirstName(parts.first);

      const lastNameInput = q('[data-finbin-lead="fullName"]');
      if (parts.last && lastNameInput) lastNameInput.value = parts.last;

      setSf("subject", "finbin säästölaskuri");
      const desc = buildDescription({ fullName, company, email, phone }, v);
      setSf("description", desc);

      try {
        sessionStorage.setItem(storageKey, JSON.stringify({ v }));
      } catch (e) {}

      showSuccess("Tulokset laskettu. Lähetetään liidi...");

      btn.disabled = true;
      setTimeout(function () {
        form.submit();
      }, 150);
    });
  }

  function boot() {
    document.querySelectorAll("[data-finbin-root]").forEach(initRoot);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }
})();
